import { StyledSparkPreview } from 'components/Sparks/Routes/AddResponseToSpark/AddPick/styled';
import { styled } from 'linaria/lib/react';

export const StyledThumbnail = styled(StyledSparkPreview)`
  margin-right: 12px;
`;
